import DiceBox from "@3d-dice/dice-box";
import { normalizeD100, total } from "./selection";
import type { DiceEngine, DiceType, DieResult, RollResult } from "./types";

type RawRoll = { sides: number | string; value: number };

/** Adapter around Dice Box: results resolve only when its physics simulation settles. */
export class DiceBoxEngine implements DiceEngine {
  private box?: DiceBox;

  async initialize(container: string): Promise<void> {
    this.box = new DiceBox({
      container,
      assetPath: "/assets/",
      theme: "default",
      themeColor: "#e8ddc1",
      offscreen: true
    });
    await this.box.init();
  }

  async roll(selection: readonly DiceType[]): Promise<RollResult> {
    if (!this.box) throw new Error("Die Würfelschale ist noch nicht bereit.");
    const notation = selection.flatMap((die) => die === 100 ? ["1d10", "1d10"] : [`1d${die}`]);
    const raw = (await this.box.roll(notation)) as RawRoll[];
    const dice: DieResult[] = [];
    let cursor = 0;

    for (const type of selection) {
      if (type === 100) {
        // Dice Box represents the d10's zero face as 10; percentile dice use 0.
        const tens = raw[cursor++].value % 10;
        const ones = raw[cursor++].value % 10;
        dice.push({ type, value: normalizeD100(tens, ones), parts: [tens, ones] });
      } else {
        dice.push({ type, value: raw[cursor++].value });
      }
    }
    return { dice, total: total(dice.map((die) => die.value)) };
  }

  clear(): void {
    this.box?.clear();
  }

  destroy(): void {
    this.clear();
    this.box = undefined;
  }
}
